<template>
    <div>
      <b-modal id="addRequestv2Modal" size="lg" class="modal has-overflow" @hide="close('addRequestv2Modal')">
        <div class="e-loader-back" v-if="loading">
          <div class="e-loader-content">
            <div class="ball-clip-rotate-multiple">
              <div></div>
              <div></div>
            </div>
            <div class="e-nusx-8 e-bold e-loader-text">იტვირთება...</div>
          </div>
        </div>
        <template v-slot:modal-header>
          <div class="w-100">
            <!--todo-->
            <h6 class="e-mtavr-17 e-bold modal-title">ახალი მოთხოვნა</h6>
          </div>
        </template>
        <b-card-body class="pt-1">
            <b-form>
              <div class="row">
                <div class="col-md-12 col-lg-12">
                <h6
                  class="
                    px-2
                    m-0
                    e-mtavr-14 e-bold
                    text-muted
                  "
                >
                  პირადი მონაცემები
                </h6>
                <hr class="border-light m-0 w-100" />
              </div>
              </div>
              <div class="row">
                <div class="col col-12 pt-2 pr-5">
                <b-form-group
                class="mb-0"
                >
                <label for="jurStat" class="e-nusx-8 text-muted"><small>იურიდიული სტატუსი </small></label>
                  <b-radio-group
                    id="jurStat"
                    size="sm"
                    class="e-nusx-8 text-muted"
                    v-model="newReqItem.juridicalStatusId"
                    @change="filterScanningDatabases"
                    :options="[
                      { text: 'ფიზიკური პირი', value: 1 },
                      { text: 'იურიდიული პირი', value: 2 },
                    ]"
                  />
                </b-form-group>
                <b-form-group
                class="mb-0"
                  v-if="newReqItem.juridicalStatusId === 1"
                >
                <label for="fname" class="e-nusx-8 text-muted"><small>დასახელება </small></label>
                  <b-input
                  placeholder="ლათინურად"
                  size="sm"
                  id="fname"
                    v-model="newReqItem.firstName"
                    class="e-eng-font"
                  />
                </b-form-group>
                <div class="row">
                  <div class="col col-6 pt-2 pr-5">
                    <b-form-group
                        v-if="newReqItem.juridicalStatusId === 1"
                         >
                        <label for="bdate" class="e-nusx-8 text-muted"><small>დაბადების თარიღი</small></label>
                        <datepicker
                          id="bdate"
                          v-model="newReqItem.brthDate"
                          :bootstrapStyling="true"
                          :language="locale"
                          :monday-first="true"
                          placeholder="თარიღი არ არის არჩეული"
                          :calendar-button="true"
                          calendar-button-icon="far fa-calendar-alt"
                          format="dd.MM.yyyy"
                        />
                    </b-form-group>
                  </div>
                  <div class="col col-6 pt-2" v-if="newReqItem.juridicalStatusId === 1">
                       <label for="DobYeardeviations" class="e-nusx-8 text-muted"><small>დაბ. თარიღის დამთხვევის ლოგიკა</small></label>
                       <b-form-select :disabled="newReqItem.brthDate === 'თარიღი არ არის არჩეული'" v-model="newReqItem.brthDateMatching" id="DobYeardeviations" class="e-nusx-7 form-control form-control-sm custom-select custom-select-sm" :options="DobYeardeviations" />
                  </div>
                </div>
                <b-form-group
                class="mb-0"
                  v-if="newReqItem.juridicalStatusId === 2"
                >
                <label for="name" class="e-nusx-8 text-muted"><small>დასახელება </small></label>
                  <b-input
                  placeholder="ლათინურად"
                    size="sm"
                    id="name"
                    v-model="newReqItem.firstName"
                    class="e-eng-font"
                  />
                </b-form-group>
                <div class="row">
                  <div class="col col-6 pt-2 pr-5" v-if="newReqItem.juridicalStatusId === 1">
                  <b-form-group
                  class="mb-0"
                  >
                <label for="gender" class="e-nusx-8 text-muted"><small>სქესი</small></label>
                  <b-radio-group size="sm" id="gender" class="e-nusx-8 text-muted font-weight-light" v-model="newReqItem.gender" :options="genderOptions" />
                  </b-form-group>
                </div>
                <!-- <div class="col col-6 pt-2 pr-5">
              <b-form-group
                  v-if="newReqItem.juridicalStatusId === 2"
                >
                <label for="countryinput" class="e-nusx-8 text-muted"><small>რეზიდენტობა</small></label>
                  <b-input
                    v-model="newReqItem.countryISO"
                    size="sm"
                    autocomplete="off"
                    id="countryinput"
                    class="e-eng-font"
                    @input="filterCountries()"
                    @focus="filterCountries(), (showPop = true)"
                    @blur="(showPop = false)"
                  />
                  <b-popover
                    id="primaryPopover-container"
                    container="primaryPopover-container"
                    target="countryinput"
                    custom-class="e-popover-danger"
                    placement="bottom"
                    triggers="manual"
                    :show.sync="showPop"
                  >
                    <ul class="e-liststyle-none e-eng-font e-listinpopover">
                      <li
                        v-for="cntry in filteredCountriesList"
                        :key="cntry.$index"
                        @click="setCountry(cntry)"
                        class="g-cursor-pointer"
                      >
                        {{ cntry.countryName }}
                      </li>
                    </ul>
                  </b-popover>
              </b-form-group>
                </div> -->

                <!-- <b-form-group
                class="mb-0"
                  v-if="newReqItem.juridicalStatusId === 1"
                >
                <label for="lname" class="e-nusx-8 text-muted"><small>გვარი </small></label>
                  <b-input size="sm" id="lname" v-model="newReqItem.lastName" class="e-eng-font" placeholder="ლათინურად"/>
                </b-form-group> -->
                </div>
                </div>
                <div class="col-md-12 col-lg-12 pr-5">
                <h6 v-b-toggle.addressPanel variant="plain" class="
                    g-mt-20
                    px-2
                    e-mtavr-14 e-bold
                    text-muted
                    cursor-pointer
                  ">მისამართის პარამეტრები
                  <span class="when-closed"><i class="fa fa-angle-down" aria-hidden="true"></i></span> <span class="when-opened"><i class="fa fa-angle-up" aria-hidden="true"></i></span>
                </h6>
                <hr class="border-light m-0 w-100" />
                <b-collapse id="addressPanel" class="mt-2 mb-5">
                  <div class="row">
                    <div class="col-12">
                      <b-form-group class="mb-0">
                    <label for="country" class="e-nusx-8 text-muted"><small>მისამართის ქვეყანა <i class="text-primary cursor-pointer e-bold" @click="wantCity = true" v-if="wantCity === false">მსურს ქალაქის მითითება</i><i class="text-secondary cursor-pointer e-bold"  @click="wantCity = false" v-if="wantCity === true">არ მსურს ქალაქის მითითება</i></small></label>
                    <span v-if="CountryNotFound && newReqItem.countryISO" id="country" class="e-nusx-8 text-primary e-ts-11">მსგავსი ქვეყანა ვერ მოიძებნა!</span>
                      <b-input
                        v-model="newReqItem.countryISO"
                        size="sm"
                        autocomplete="off"
                        id="countryinput"
                        class="e-eng-font"
                        @input="filterCountries()"
                        @focus="filterCountries(), (showPop = true)"
                        @blur ="(showPop = false)"
                      />
                      <b-popover
                        id="primaryPopover-container"
                        container="primaryPopover-container"
                        target="countryinput"
                        custom-class="e-popover-danger"
                        placement="bottom"
                        triggers="manual"
                        :show.sync="showPop"
                      >
                        <ul class="e-liststyle-none e-eng-font e-listinpopover">
                          <li
                            v-for="cntry in filteredCountriesList"
                            :key="cntry.$index"
                            @click="setCountry(cntry)"
                            class="g-cursor-pointer"
                          >
                            {{ cntry.countryName }}
                          </li>
                        </ul>
                      </b-popover>
                      <div class="row">
                        <div class="col-3" v-for="cl in AddressArray" :key="cl.$index">
                          <div class="col-12 pl-0">
                            <div class="badge rounded-pill badge-secondary g-mr-3 g-mt-4">{{ cl.countryName }} <i class="fas fa-times" @click="removeCountry(cl.twoChar)"></i></div>
                          </div>
                          <div class="col-12 pl-0 pt-1">
                            <b-input v-if="wantCity"
                            size="sm"
                            type="text"
                            v-model="cl.City"
                            @input="generateStrings"
                          />
                          </div>
                        </div>
                      </div>

                    </b-form-group>
                    <!-- {{ AddressArray }}
                    {{ newReqItem.countryISOstr }}
                    {{ newReqItem.citystr }} -->
                    </div>
                  </div>
                </b-collapse>
                </div>
                <div class="col-md-12 col-lg-12 pr-5">
                <h6 v-b-toggle.collapse variant="plain" class="
                    g-mt-20
                    px-2
                    e-mtavr-14 e-bold
                    text-muted
                    cursor-pointer
                  ">ძებნის დამატებითი პარამეტრები
                  <span class="when-closed"><i class="fa fa-angle-down" aria-hidden="true"></i></span> <span class="when-opened"><i class="fa fa-angle-up" aria-hidden="true"></i></span>
                </h6>
                <hr class="border-light m-0 w-100" />
                <b-collapse id="collapse" class="mt-2 mb-5">
                  <div class="row">
                    <div class="col-6">
                      <label for="policyOptionsGeography" class="e-nusx-8 text-muted"><small>გეორგრაფიული</small></label>
                      <b-form-select v-model="newReqItem.countryRequired" id="policyOptionsGeography" class="e-nusx-7 custom-select custom-select-sm" :options="policyOptionsGeography"/>
                    </div>
                    <div class="col-6"
                      v-if="newReqItem.juridicalStatusId === 1"
                      >
                      <label for="dobPolicy" class="e-nusx-8 text-muted"><small>დაბადების თარიღი </small></label>
                      <b-form-select v-model="newReqItem.brthDateRequired" id="dobPolicy" class="e-nusx-7 custom-select custom-select-sm" :options="policyOptionsDOB" />
                    </div>
                  </div>
                </b-collapse>
              </div>
              </div>
              <div class="row">
                <div class="col-md-12 col-lg-12">
                <h6
                  class="
                    py-2
                    px-2
                    m-0
                    e-mtavr-14 e-bold
                    text-muted
                  "
                >
                  სამიზნე ბაზები
                </h6>
                <hr class="border-light m-0 w-100" />
              </div>
              <div class="col col-12 pt-4 ">
                <b-form-group
                  inline
                  label="გადასამოწმებელი ბაზები"
                  class="e-nusx-8 e-bold text-muted"
                >
                  <b-form-checkbox
                    v-model="selectAll"
                    size="sm"
                    class="mt-4"
                    type="checkbox"
                  >
                    <span class="e-nusx-8 e-bold">ყველას მონიშვნა</span>
                  </b-form-checkbox>
                    <b-form-checkbox
                    v-for="scdb in scannigPacketDatabasesFiltered" :key="scdb.$index"
                    inline
                    size="sm"
                      v-model="newReqItem.scannigPacketDatabases"
                      :value="scdb.id"
                      class=""
                    >
                      <span class="e-text-eng-1 e-bold" v-b-tooltip.hover :title="scdb.description">{{ scdb.name }}</span>
                    </b-form-checkbox>
                </b-form-group>
              </div>
              <div class="col col-12 pt-4">
                <b-form-group
                  label="დამთხვევის %"
                  class="e-nusx-8 e-bold text-muted"
                >
                  <vue-slider
                    ref="Coinsidence_slider"
                    v-model="newReqItem.matchPercent"
                    :tooltip="'always'"
                    :min="75"
                  ></vue-slider>
                </b-form-group>
              </div>
              </div>
            </b-form>
        </b-card-body>
        <template v-slot:modal-footer>
          <div class="w-100">
            <b-button
              size="sm"
              variant="btn btn-primary"
              :disabled="CountryNotFound || (newReqItem.juridicalStatusId === 1 && !newReqItem.firstName ) || (newReqItem.juridicalStatusId === 2 && !newReqItem.firstName)"
              @click="save()"
              class="float-right e-mtavr-17"
              >გადამოწმება</b-button
            >
            <b-button
              size="sm"
              variant="btn btn-secondary"
              @click="close('addRequestv2Modal')"
              class="float-right e-mtavr-17 mr-2"
              >გაუქმება</b-button
            >
          </div>
        </template>
      </b-modal>
    </div>
  </template>

<script>
import 'loaders.css/loaders.css'
import 'spinkit/spinkit.css'
import BaseService from '@/backend/vue-axios/axios.js'
import Datepicker from 'vuejs-datepicker'
import { ge } from 'vuejs-datepicker/dist/locale'
import vueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/ething-material.css'
import moment from 'moment'
export default {
  components: {
    vueSlider,
    Datepicker
  },
  // metaInfo: {
  //   title: ' - ახალი მოთხოვნის დატამება'
  // },
  data () {
    return {
      loading: false,
      showPop: false,
      CountryNotFound: false,
      fullCountryList: [],
      filteredCountriesList: [],
      scanningPackets: this.$store.getters.GetscanningPackets,
      scannigPacketDatabases: this.$store.getters.GetscannigPacketDatabases,
      isCollapseOpen: false,
      AddressArray: [],
      wantCity: false,
      // scannigPacketDatabases: [
      //   {
      //     id: 'PEP',
      //     scanningPacketID: 3,
      //     name: 'PEP',
      //     description:
      //       'Search all Politically Exposed Persons: current, former and linked'
      //   },
      //   {
      //     id: 'PEP-CURRENT',
      //     scanningPacketID: 3,
      //     name: 'PEP-Current',
      //     description: 'Search only the current Politically Exposed Persons'
      //   },
      //   {
      //     id: 'PEP-Former',
      //     scanningPacketID: 3,
      //     name: 'PEP-FORMER',
      //     description: 'Search only the former Politically Exposed Persons'
      //   },
      //   {
      //     id: 'PEP-Linked',
      //     scanningPacketID: 3,
      //     name: 'PEP-LINKED',
      //     description:
      //       'Search only the Politically Exposed Persons by association'
      //   },
      //   {
      //     id: 'SAN',
      //     scanningPacketID: 3,
      //     name: 'SAN - Sanctions',
      //     description: 'Search all Sanctions: current and former'
      //   },
      //   {
      //     id: 'SAN-CURRENT',
      //     scanningPacketID: 3,
      //     name: 'SAN-Sanctions current',
      //     description: 'Search only current Sanctions'
      //   },
      //   {
      //     id: 'SAN-FORMER',
      //     scanningPacketID: 3,
      //     name: 'SAN-Sanctions Former',
      //     description: 'Search only former Sanctions'
      //   },
      //   {
      //     id: 'INS',
      //     scanningPacketID: 3,
      //     name: 'INS - Insolvency (UK & Ireland Only)',
      //     description: 'INS - Insolvency (UK Only)'
      //   },
      //   {
      //     id: 'RRE',
      //     scanningPacketID: 3,
      //     name: 'RRE - Reputational Risk Exposure (Include Advarse Media)',
      //     description: 'Reputational Risk Exposure'
      //   },
      //   {
      //     id: 'DD',
      //     scanningPacketID: 3,
      //     name: 'DD - Disqualified Director (UK Only)',
      //     description: 'DD - Disqualified Director'
      //   },
      //   {
      //     id: 'POI',
      //     scanningPacketID: 3,
      //     name: 'POI',
      //     description: 'Profiles of Interest'
      //   },
      //   {
      //     id: 'REL',
      //     scanningPacketID: 3,
      //     name: 'REL',
      //     description: 'Regulatory Enforcement List'
      //   }
      // ],
      purchasedScanningPackage: this.$store.getters.GetPurchasedScanningPacket,
      // currentUser: this.$store.getters.GetCurrentUser,
      header: {
        headers: {
          accept: 'text/plain',
          Authorization: 'Bearer ' + this.$store.getters.getAccessToken
        }
      },
      newReq: {
        request: {
          id: 0,
          recDate: '',
          matchPercent: 80,
          firstName: '',
          lastName: '',
          country: '',
          countryISO: '',
          personalN: '',
          address: '',
          brthDate: 'თარიღი არ არის არჩეული',
          transactionN: '',
          scanningTypeId: 0,
          scanningType: '',
          scanningPacketId: 1,
          scanningPacketName: '',
          scanningDatabases: [],
          decisionResultId: 0,
          decisionResult: '',
          decisionUserId: 0,
          decisionUser: '',
          addingReasonId: 0,
          addingReason: '',
          organisationId: 0,
          userId: 0,
          userName: '',
          userFirstName: '',
          userLastName: '',
          statusChangeDate: null,
          statusChangeUserId: 0,
          statusChangeUserName: '',
          status: 0,
          statusText: '',
          matchedBlackListId: 0,
          matchedWhiteListId: 0,
          dboforigination: '',
          commentText: '',
          commentUserId: 0,
          commentUserName: '',
          matchCount: 0,
          deleteStatus: false,
          organisationUserId: 0,
          juridicalStatusId: 1,
          checkInAcuris: true,
          comments: [],
          scannigPacketDatabases: []
        }
      },
      newReqItem: {
        matchPercent: 80,
        juridicalStatusId: 1,
        firstName: '',
        lastName: '',
        gender: null,
        countryRequired: false,
        brthDateRequired: false,
        brthDateMatching: null,
        countryISO: '',
        city: '',
        postalCode: '',
        address: '',
        personalN: '',
        documentN: '',
        registrationN: '',
        clientNumber: '',
        brthDate: 'თარიღი არ არის არჩეული',
        transactionN: '',
        scanningTypeId: 0,
        scanningPacketId: 0,
        addingReasonId: 0,
        checkInAcuris: true,
        requestForClient: false,
        comments: [],
        scannigPacketDatabases: [],
        version: 1
      },
      genderOptions: [
        { text: 'მამრობითი', value: 'Male' },
        { text: 'მდედრობითი', value: 'Female' }
      ],
      policyOptionsDOB: [
        { value: false, text: 'ყველა შესაძლო ვარიანტი' },
        { value: true, text: 'დაბ. თარიღის მქონე პირებში' }
      ],
      DobYeardeviations: [
        { value: 'exact', text: 'ზუსტი დამთხვევა' },
        { value: 'sameYear', text: 'იმავე წელს' },
        { value: 'withinOneYear', text: '1 წლის ფარგლებში' },
        { value: 'withinTwoYears', text: '2 წლის ფარგლებში' },
        { value: 'withinThreeYears', text: '3 წლის ფარგლებში' },
        { value: 'withinFourYears', text: '4 წლის ფარგლებში' },
        { value: 'withinFiveYears', text: '5 წლის ფარგლებში' }
      ],
      bNewReqItem: {
        matchPercent: 80,
        juridicalStatusId: 1,
        firstName: '',
        lastName: '',
        gender: '',
        countryISO: '',
        city: '',
        postalCode: '',
        address: '',
        personalN: '',
        documentN: '',
        registrationN: '',
        clientNumber: '',
        brthDate: 'თარიღი არ არის არჩეული',
        transactionN: '',
        scanningTypeId: 0,
        scanningPacketId: 0,
        addingReasonId: 0,
        checkInAcuris: true,
        requestForClient: false,
        comments: [],
        scannigPacketDatabases: [],
        version: 1
      },

      locale: ge
    }
  },
  created () {
    this.generateStrings()
    this.filterScanningDatabases()
    this.selectAll = true
    this.scannigPacketDatabases = this.scannigPacketDatabases.filter(
      (sdb) =>
        sdb.scanningPacketID === this.purchasedScanningPackage.scanningPacketId
        // (sdb) => sdb.scanningPacketID === this.purchasedScanningPackage
    )
    this.newReqItem.scanningPacketId =
        this.purchasedScanningPackage.scanningPacketId
  },
  computed: {
    currentUser () {
      return this.$store.getters.GetCurrentUser
    },
    policyOptionsGeography () {
      return [
        { value: false, text: 'ყველა შესაძლო ვარიანტი' },
        {
          value: true,
          text:
            this.newReqItem.juridicalStatusId === 1
              ? 'რეზიდენტობის მქონე პირებში'
              : 'რეზიდენტობის მქონე პირებში'
        }
      ]
    },
    scannigPacketDatabasesFiltered () {
      return this.scannigPacketDatabases.filter(item => item.scanningPacketID === this.newReqItem.scanningPacketId)
    },
    state () {
      return this.newReqItem.firstName.length >= 4
    },
    invalidFeedback () {
      if (this.newReqItem.firstName.length > 0) {
        return 'აუცილებელია მინიმუმ 4 სიმბოლო!'
      }
      return 'პარამეტრი აუცილებელია'
    },
    selectAll: {
      get: function () {
        return this.scannigPacketDatabases
          ? this.newReqItem.scannigPacketDatabases.length ===
                this.scannigPacketDatabases.length
          : false
      },
      set: function (value) {
        var selected = []
        if (value) {
          this.scannigPacketDatabases.forEach(function (SDB) {
            selected.push(SDB.id)
          })
        }
        this.newReqItem.scannigPacketDatabases = selected
      }
    }
  },
  methods: {
    test () {
    },
    filterScanningDatabases () {
      this.scannigPacketDatabases = this.$store.getters.getFilteredPacketDatabases(this.newReqItem.juridicalStatusId)
      this.loading = false
      this.selectAll = true
      this.newReqItem.firstName = ''
      this.newReqItem.lastName = ''
      this.newReqItem.brthDate = 'თარიღი არ არის არჩეული'
      this.newReqItem.countryISO = ''
      this.newReqItem.personalN = ''
      this.newReqItem.gender = ''
      this.newReqItem.countryISOstr = ''
      this.newReqItem.citystr = ''
      this.newReqItem.city = ''
      this.newReqItem.brthDateMatching = null
      this.newReqItem.countryRequired = false
      this.newReqItem.brthDateRequired = false
      this.AddressArray = []
      this.wantCity = false
    },
    save () {
      this.loading = true
      // this.newReqItem.recDate = moment(Date.now()).format()
      // this.newReqItem.organisationId = this.currentUser.organizationID
      // this.newReqItem.userId = this.currentUser.id
      // this.newReqItem.userName = this.currentUser.userName
      // this.newReqItem.userFirstName = this.currentUser.firstName
      // this.newReqItem.userLastName = this.currentUser.lastName
      // this.newReqItem.userLastName = this.currentUser.lastName
      if (this.newReqItem.brthDate === 'თარიღი არ არის არჩეული' || this.newReqItem.brthDate === '' || this.newReqItem.brthDate === null) {
        this.newReqItem.brthDate = null
      } else {
        this.newReqItem.brthDate = moment(this.newReqItem.brthDate).format('YYYY-MM-DD')
      }
      // console.log(this.newReqItem)
      BaseService.AddRequestWithDetailsv2(this.header, this.newReqItem).then(
        (res) => {
          if (res.data.success) {
            this.loading = false
            this.selectAll = true
            this.loading = false
            this.selectAll = true
            this.newReqItem.firstName = ''
            this.newReqItem.lastName = ''
            this.newReqItem.brthDate = 'თარიღი არ არის არჩეული'
            this.newReqItem.countryISO = ''
            this.newReqItem.personalN = ''
            this.newReqItem.gender = ''
            this.newReqItem.juridicalStatusId = 1
            this.newReqItem.countryISOstr = ''
            this.newReqItem.citystr = ''
            this.newReqItem.city = ''
            this.newReqItem.brthDateMatching = null
            this.newReqItem.countryRequired = false
            this.newReqItem.brthDateRequired = false
            this.AddressArray = []
            this.wantCity = false
            // this.newReq.request.scannigPacketDatabases = []
            this.$bvModal.hide('addRequestv2Modal')
            this.$emit('RequestAdded')
            this.$store.commit('DCRSsearches')
          }
        }
      )
      // console.log(this.newReq)
    },
    updateCity (twoChar, city) {
      // eslint-disable-next-line no-debugger
      debugger
      const countryObj = this.AddressArray.find(item => item.twoChar === twoChar)
      if (countryObj) {
        countryObj.City = city
        this.generateStrings()
      }
    },
    generateStrings () {
      this.newReqItem.countryISOstr = this.AddressArray.map(item => item.twoChar).join('|')
      if (this.wantCity) {
        this.newReqItem.citystr = this.AddressArray.map(item => item.City || '').join('|')
      }
    },
    removeCountry (twoChar) {
      this.AddressArray = this.AddressArray.filter(item => item.twoChar !== twoChar)

      // Regenerate strings after removal
      this.generateStrings()
    },
    close (id) {
      this.loading = false
      this.selectAll = true
      this.newReqItem.firstName = ''
      this.newReqItem.lastName = ''
      this.newReqItem.brthDate = 'თარიღი არ არის არჩეული'
      this.newReqItem.countryISO = ''
      this.newReqItem.personalN = ''
      this.newReqItem.gender = ''
      this.newReqItem.juridicalStatusId = 1
      this.newReqItem.countryISOstr = ''
      this.newReqItem.citystr = ''
      this.newReqItem.city = ''
      this.newReqItem.brthDateMatching = null
      this.newReqItem.countryRequired = false
      this.newReqItem.brthDateRequired = false
      this.AddressArray = []
      this.wantCity = false
      this.$bvModal.hide(id)
    },
    filterCountries () {
      // debugger // eslint-disable-line
      if (this.filteredCountriesList.length === 0) {
        this.showPop = false
        this.filteredCountriesList = this.fullCountryList
        this.CountryNotFound = true
      } else {
        this.CountryNotFound = false
      }
      // console.log(this.fullCountryList.filter((cntry) => {
      //   // debugger // eslint-disable-line
      //   this.showPop = true
      //   return cntry.twoCharCountryCode
      //     .toLowerCase()
      //     .startsWith(this.newReqItem.countryISO.toLowerCase())
      // }))
      this.filteredCountriesList = this.fullCountryList.filter((cntry) => {
        // debugger // eslint-disable-line
        // console.log('cntry:' + cntry.countryName)
        this.showPop = true
        return cntry.countryName
          .toLowerCase()
          .startsWith(this.newReqItem.countryISO.toLowerCase())
      })
    },
    setCountry (data) {
      // this.newReqItem.countryISO = data.countryName
      this.newReqItem.country = data.countryName
      this.newReqItem.CountryCodeTmp = data.twoCharCountryCode
      this.showPop = false
      var countryMappingItem = {
        countryName: data.countryName,
        twoChar: data.twoCharCountryCode,
        city: ''
      }
      this.AddressArray.push(countryMappingItem)
      this.generateStrings()
      this.newReqItem.countryISO = ''
    }
  },
  mounted () {
    this.fullCountryList = this.$store.getters.GetCountriesList
  }
}
</script>
  <style>
    #bdate {
      height: calc(1.5em + 0.376rem + 2px)!important;
      padding: 0.188rem 0.625rem;
      font-size: 0.75rem;
      line-height: 1.5;
      border-top-right-radius: 0.25rem;
      border-bottom-right-radius: 0.25rem;
    }
    .input-group-text{
      height: calc(1.5em + 0.376rem + 2px)!important;
      padding: 0;
      max-height: calc(1.5em + 0.376rem - 1px);
    }
    .input-group-prepend {
      height: calc(1.5em + 0.376rem + 2px)!important;
    }
    :root {
      --dp-button-icon-height: 20px;
    }

    .collapsed > .when-opened,
:not(.collapsed) > .when-closed {
  display: none;
}
  </style>
